import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

import { onNotificationClose } from '../utils/onNotificationClose';
import { onSpaceAdminNotificationClick } from '../utils/onSpaceAdminNotificationClick';
import { prepareNotificationOptions } from '../utils/prepareNotificationOptions';

export const handleSpaceAdminNotification = (pushNotification: IPushNotification): void => {
  if (!pushNotification.spaceId) {
    return;
  }

  const options = prepareNotificationOptions(pushNotification);

  const notification = new Notification(pushNotification.title || '', options);
  Entities.pushNotifications.addNotification(notification);
  notification.onclick = (): Promise<void> =>
    onSpaceAdminNotificationClick(pushNotification, notification);
  notification.onclose = (): void => onNotificationClose(notification);
  notification.onerror = (): void => onNotificationClose(notification);
};
